export default "__VITE_ASSET__izDmm_3w__"